<div class="twc-row twc-pt-3" [ngClass]="{'upload-bar-align-end': !showUploadControlButtons}">
    <div class="twc-col-7 text-align-right" *ngIf="showUploadControlButtons">
        <button class="twc-button twc-button-link twc-button-icon" *ngIf="isLoading() || isPaused()"
            [twcTooltip]="'GENERAL.CANCEL' | translate" placement="top" (click)="clickCancel()">
            <twc-icon shape="close" [size]="32"></twc-icon>
        </button>
        <button class="twc-button twc-button-link twc-button-icon" *ngIf="isLoading()"
            [twcTooltip]="'JOBS.PAUSE' | translate" placement="top" (click)="clickPause()">
            <twc-icon shape="pause" [size]="32"></twc-icon>
        </button>
        <button class="twc-button twc-button-link twc-button-icon" *ngIf="isPaused()"
            [twcTooltip]="'JOBS.RESUME' | translate" placement="top" (click)="clickContinue()">
            <twc-icon shape="play" [size]="32"></twc-icon>
        </button>
    </div>
    <div class="twc-col-5">
        <twc-progress-bar *ngIf="!uploadInfo?.isProgressBarHidden && uploadInfo?.upload?.status && !isCanceled()"
            class="width-100" [height]="'xl'" [progress]="getProgressProcess()" [type]="getTypeProcess()"
            [label]="(getLabelProcess() | translate) + getRemaining()" [progressLabelPlacement]="'right'">
        </twc-progress-bar>

        <div *ngIf="isCanceled()" class="twc-message-box twc-message-box-warning">
            {{'JOBS.INCOMPLETE' | translate}}
        </div>
    </div>
</div>

<div class="list-block">
    <div class="layout-options-block">
        <table class="twc-table twc-table-adaptive" attr.aria-describedby="{{'UPLOAD.UPLOAD_FILES_TABLE_DESC' | translate}}">
            <thead>
                <tr>
                    <th>{{ 'EMBED.SUMMARY_LABELS.NAME' | translate }}</th>
                    <th>{{ 'EMBED.SUMMARY_LABELS.SIZE' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let file of files">
                    <td>{{ file.name | translate}}</td>
                    <td>{{ file.size | bytes }}</td>
                    <td>
                        <twc-progress-bar *ngIf="getFileInfo(file) as fileInfo" class="width-100"
                            [progress]="getProgress(file)" [ngClass]="{indeterminate: fileInfo.isIndeterminate}"
                            [type]="getType(file)" [label]="getLabel(file) | translate"
                            [progressLabelPlacement]="'right'">
                        </twc-progress-bar>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>